import React, { useState, useEffect } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Menu, X, Calendar } from 'lucide-react';

const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <nav className={`sticky top-0 z-50 w-full transition-all duration-300
      ${scrolled ? 'shadow-sm' : ''}
      bg-provence-limestone/95 border-b border-provence-stone/10
      backdrop-blur supports-[backdrop-filter]:bg-provence-limestone/80`}
    >
      <div className="container flex h-20 items-center justify-between">

        {/* Logo */}
        <NavLink to="/" className="flex items-center gap-3 group">
          <div className="flex flex-col leading-none">
            <span className="text-2xl font-serif font-bold tracking-widest text-provence-stone group-hover:text-provence-lavender transition-colors duration-300 italic">
              Mas Capon
            </span>
            <span className="text-[10px] font-sans font-medium tracking-[0.25em] text-provence-terracotta uppercase">
              Saint-Rémy-de-Provence
            </span>
          </div>
        </NavLink>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-8">
          <NavLink
            to="/galerie"
            className={({ isActive }) => `
              text-base font-sans font-medium tracking-wide transition-colors duration-200
              relative pb-0.5 after:absolute after:bottom-0 after:left-0 after:right-0
              after:h-px after:bg-provence-lavender after:transition-transform after:duration-200
              ${isActive
                ? 'text-provence-lavender after:scale-x-100'
                : 'text-provence-stone/70 hover:text-provence-stone after:scale-x-0 hover:after:scale-x-100'}
            `}
          >
            Galerie
          </NavLink>

          <NavLink
            to="/kontakt"
            className={({ isActive }) => `
              inline-flex items-center gap-2 btn-provence text-sm tracking-wide
              ${isActive ? 'opacity-90' : ''}
            `}
          >
            <Calendar className="h-4 w-4" />
            Anfrage senden
          </NavLink>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden p-2 rounded-md text-provence-stone hover:bg-provence-stone/8 transition-colors"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menü"
        >
          {menuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden border-t border-provence-stone/10 bg-provence-limestone animate-fade-in">
          <div className="container py-4 flex flex-col gap-3">
            <NavLink
              to="/galerie"
              className={({ isActive }) =>
                `px-4 py-3 rounded-md font-sans text-sm font-medium transition-colors
                ${isActive ? 'bg-provence-lavender/10 text-provence-lavender' : 'text-provence-stone hover:bg-provence-stone/5'}`
              }
            >
              Galerie
            </NavLink>
            <NavLink to="/kontakt" className="mx-4 mb-2 btn-provence text-sm text-center">
              Anfrage senden
            </NavLink>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
